import CancelEventsModal from './CancelEventsModal';

export default CancelEventsModal;
